import objectFitImages from 'object-fit-images';
objectFitImages();

import initRellax from './modules/rellax';
initRellax();

import initAnimation from './modules/animation';
initAnimation();

const arrowStyleButtons = document.querySelectorAll('.wp-block-button[class *= is-style-arrow-]');
arrowStyleButtons.forEach(node => {
    const linkNode = node.querySelector('.wp-block-button__link');
    if (linkNode) {
        if (node.className.indexOf('is-style-arrow-left') > -1) {
            linkNode.innerHTML = '<svg class="wp-block-button__arrow wp-block-button__arrow--left" viewBox="0 0 10 19"><path style="stroke-width:0px;" d="m9.69,17.02l-6.96-7.51L9.65,1.97c.43-.47.41-1.22-.06-1.66-.46-.44-1.19-.42-1.63.06L.31,8.72c-.41.45-.41,1.15,0,1.6l7.7,8.31c.44.47,1.17.49,1.63.05.46-.44.48-1.19.05-1.66Z"></svg>' + linkNode.innerHTML;
        } else if (node.className.indexOf('is-style-arrow-right') > -1) {
            linkNode.innerHTML += '<svg class="wp-block-button__arrow wp-block-button__arrow--right" viewBox="0 0 10 19"><path style="stroke-width:0px;" d="m.31,1.98l6.96,7.51L.35,17.03c-.43.47-.41,1.22.06,1.66.46.44,1.19.42,1.63-.06l7.66-8.35c.41-.45.41-1.15,0-1.6L1.99.37C1.55-.1.82-.12.36.32c-.46.44-.48,1.19-.05,1.66Z"></svg>';
        }
    }
});




